module.exports = __webpack_public_path__ + "static/media/mil3idly.9d4e6a94.png";